import {Record, List} from 'immutable';

interface RawResultPerson {
    image: {
        small: string;
        large: string;
        empty: boolean;
    };
    name?: string[];
    group?: {
        id: string;
        name: string;
    };
    age?: string[];
    [x: string]: any;
}

interface RawResults {
    pdf: string;
    csv: string;
    children?: Array<
        RawResultPerson & {
            childId: string;
        }
    >;
    employees?: Array<
        RawResultPerson & {
            employeeId: string;
        }
    >;
    totalChildren?: number;
    totalEmployees?: number;
}

export enum PersonType {
    child = 'child',
    employee = 'employee',
}

export class Child extends Record<{
    readonly childId: string;
    readonly info: {[x: string]: any};
    readonly type: PersonType.child;
}>({
    childId: '',
    info: {},
    type: PersonType.child,
}) {}

export class Employee extends Record<{
    readonly employeeId: string;
    readonly info: {[x: string]: any};
    readonly type: PersonType.employee;
}>({
    employeeId: '',
    info: {},
    type: PersonType.employee,
}) {}

class ListResults extends Record<{
    readonly children: List<Child>;
    readonly totalChildren: number;
    readonly employees: List<Employee>;
    readonly totalEmployees: number;
    readonly pdf: string;
    readonly csv: string;
}>({
    children: List(),
    totalChildren: 0,
    employees: List(),
    totalEmployees: 0,
    pdf: '',
    csv: '',
}) {}

const fromAPI = (response: RawResults) => {
    return new ListResults({
        ...response,
        children: List(
            response.children
                ? response.children.map(
                      ({childId, ...rest}) =>
                          new Child({
                              childId,
                              info: rest,
                          }),
                  )
                : [],
        ),
        employees: List(
            response.employees
                ? response.employees.map(
                      ({employeeId, ...rest}) =>
                          new Employee({
                              employeeId,
                              info: rest,
                          }),
                  )
                : [],
        ),
    });
};

export const Results = {
    fromAPI,
    default: new ListResults(),
};
